import { api } from './api';
import { currentSessionId } from './sessionState';

let logoutRequest = null;
export const authenticate = async (path, payload) => {
  if (logoutRequest) await logoutRequest;
  const { data } = await api.post(path, payload);
  return data;
};
export const endSession = (idle = false) => {
  if (!logoutRequest) {
    const headers = { 'X-Session-Id': currentSessionId() || '' };
    logoutRequest = api.post(idle ? '/auth/idle-logout' : '/auth/logout', null, { headers }).finally(() => { logoutRequest = null; });
  }
  return logoutRequest;
};